import React, { Component } from "react";
import { Modal, ModalBody, ModalHeader, Row, Col } from "reactstrap";
import { profilePicValidityCheck } from "../../utils/constants";

export default class SharedUsersModal extends Component {
  getInitials = user => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  viewMember = user => {
    let link = `/home/${this.props.user.profile.organizationId._id}/profile/${user.userId}`;
    this.props.history.push(link);
  };

  render() {
    const { open, users, toggle } = this.props;
    return (
      <Modal isOpen={open} className="shared-users-popup">
        <ModalHeader toggle={toggle} className="dashboardHeader">Shared with users</ModalHeader>
        <ModalBody>
          <div>
            {users.length > 0 ? (
              <div className="m-1">
                <ul className="shared-users-popup-table responsive-table">
                  <li className="table-header member-no-show-mob">
                    <div className="col col-6">Picture</div>
                    <div className="col col-5">Name</div>
                  </li>

                  {users.map(item => {
                    return (
                      <span
                        className="grp_member_item_row_container"
                        key={item.userId}
                      >
                        <li
                          className={`table-row cursor-pointer`}
                          onClick={() => this.viewMember(item)}
                        >
                          <div className="col col-6" data-label="Picture">
                            <div className="grp_member_profile_image cursor-pointer">
                              {profilePicValidityCheck(item.profilePic) ? (
                                <div className="list-item__avatar">
                                  <img src={item.profilePic} />
                                </div>
                              ) : (
                                <span
                                  className="list-item__avatar"
                                  data-letters={this.getInitials(item)}
                                ></span>
                              )}
                            </div>
                          </div>

                          <div className="col col-5" data-label="Name">
                            <div className="linkedToolView pt-2">
                              {item.firstName} {item.lastName} 
                            </div>
                          </div>
                        </li>
                      </span>
                    );
                  })}
                </ul>
              </div>
            ) : (
              <div className="text-center my-4"> No users</div>
            )}
          </div>
        </ModalBody>
      </Modal>
    );
  }
}
